<template>
  <div class="search">
    <div class="input-wrap">
      <div class="search-input">
        <img class="btn" src="~assets/icons/svg/icon/search-greyicon.svg" />
        <div id="#tickt" />
        <input
          v-model="searchText"
          autofocus="autofocus"
          type="text"
          :placeholder="$t('search.searchInputPlaceholder')"
          class="input"
          @input="goToSearch(searchText)"
        />
        <span class="cancel" @touchend="cancelSearch">{{
          $t('search.cancel')
        }}</span>
      </div>
    </div>

    <div v-if="visible" class="loading">
      <div class="loading-icon">
        <q-spinner-ios size="16px" class="icon" />
        <span>{{ $t('search.searchIn') }}</span>
      </div>
    </div>
    <div v-if="showList && productList.length > 0" class="product-list">
      <div class="categray">
        <q-list v-for="cateItem in productList" :key="cateItem.id">
          <q-item
            :key="cateItem.id"
            clickable
            class="q-pt-none"
            @click="onOpenDetail(cateItem.id)"
          >
            <ProductCard :product="cateItem" :search="searchText" />
          </q-item>
        </q-list>
      </div>
    </div>
    <div v-if="showList && productList.length === 0" class="no-product">
      <q-img basic class="img" src="~assets/icons/svg/icon/noProduct.svg" />
      <div class="text">
        {{ $t('search.emptyMsg') }}
      </div>
    </div>
    <SkuPicker ref="skuRef" :product-id="selectId" />
  </div>
</template>

<script>
import { getSearchProductList } from 'src/api/list.js';

import _ from 'lodash';
import SkuPicker from 'src/components/SkuPicker.vue';
import ProductCard from './components/ProductCard.vue';

export default {
  components: {
    ProductCard,
    SkuPicker,
  },
  data() {
    return {
      selectId: null,
      readyOrderCount: 0,
      searchText: '',
      productList: [],
      visible: false,
      showList: false,
    };
  },
  watch: {
    searchText: {
      handler(val) {
        if (val === '') {
          this.showList = false;
          this.productList = [];
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    goToSearch(val) {
      if (val !== '') {
        this.visible = true;
        this.showList = false;
        this.productList = [];
        this.clearTimer();
        this.timer = setTimeout(() => {
          const params = {
            keyword: val,
          };
          getSearchProductList(params).then((res) => {
            if (res?.code === 200) {
              this.visible = false;
              this.productList = res.data;

              this.showList = true;
            }
          });
        }, 500);
      } else {
        this.clearTimer();
        this.showList = false;
        this.visible = false;
        this.productList = [];
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    cancelSearch() {
      this.searchText = '';
      this.productList = [];
      this.$router.push({ path: `/${this.storeUrl}/products-list` });
    },
    onOpenDetail(id) {
      this.selectId = id;
      this.$refs.skuRef.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  .input-wrap {
    position: sticky;
    top: 64px;
    width: 100%;
    z-index: 3;
    background: #fff;
    .search-input {
      margin: 0 16px;
      height: 55px;

      border-bottom: 1px solid #d1d5db;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        width: 16px;
        height: 16px;
        margin: 9px;
      }
      .input {
        width: 100%;
        border: none;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        caret-color: $primary;
      }
      .input:focus {
        outline: none;
      }
      .cancel {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: $primary;
      }
    }
  }
  .loading {
    margin-top: 120px;
    display: flex;
    justify-content: center;
    .loading-icon {
      .icon {
        color: #d1d5db;
      }
      span {
        color: #d1d5db;
        margin-left: 8px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 120%;
      }
    }
  }
  .product-list {
    margin-top: 55px;
  }
  .no-product {
    margin-top: 104px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .img {
      width: 75px;
      height: 42px;
    }
    .text {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 120%;
      margin-top: 16px;
      color: #d1d5db;
    }
  }
}
</style>
